import { useEffect } from 'react';
import moment from 'moment';

import { LANG_STORAGE_KEY, Language } from '@/shared/config';

import 'moment/dist/locale/ru';

export const useInitMoment = () => {
  useEffect(() => {
    moment.locale(localStorage.getItem(LANG_STORAGE_KEY) || Language.Russian);
  }, []);
};
